import { overflow } from "@prismicio/editor-support/String"
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  ToolbarSeparator,
} from "@prismicio/editor-ui"
import type { Editor } from "@tiptap/core"

import { createRunCommandsFn } from "../../models/MenuItems"
interface NodeItemsProps {
  labels: string[]
  editor: Editor
}

export function LabelItems(props: NodeItemsProps) {
  const { labels, editor } = props

  const currentLabel = editor.getAttributes("label")["label"] as
    | string
    | undefined

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger disabled={labels.length === 0}>
          <Button endIcon="arrowDropDown" size="small" color="grey">
            {limitDisplayCharacters(currentLabel ?? "Labels")}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          asPortal={false}
          maxHeight={256}
          avoidCollisions={false}
        >
          {labels.map((label, index) => {
            const selected = currentLabel === label

            return (
              <DropdownMenuItem
                key={`${label}-${index}`}
                onSelect={() => {
                  if (selected) return editor.commands.unsetLabel()

                  return selectLabel(editor, label)
                }}
                endIcon={selected && <Icon name="check" size="extraSmall" />}
              >
                {limitDisplayCharacters(label)}
              </DropdownMenuItem>
            )
          })}
        </DropdownMenuContent>
      </DropdownMenu>
      <ToolbarSeparator />
    </>
  )
}

function selectLabel(editor: Editor, label: string) {
  const setLabel = createRunCommandsFn((commands) =>
    commands.setLabel({ label }),
  )
  setLabel(editor)
}

function limitDisplayCharacters(label: string) {
  return overflow(label, 20)
}
